import { useEffect } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const ConfirmDialog = (props) => {

    useEffect(() => {

        const showDialog = async () => {

            const result = await MySwal.fire({
                title: props.header || 'Confirmação',

                html: <div>{props.message}</div>,

                icon: props.variant === 'danger' ? 'warning' :
                    props.variant === 'success' ? 'success' :
                        props.variant === 'info' ? 'info' : 'question',

                showCancelButton: true,
                confirmButtonText: 'Confirmar',
                cancelButtonText: 'Cancelar',

                confirmButtonColor: '#0d6efd',
                cancelButtonColor: '#6c757d',

                reverseButtons: true,
                focusCancel: true,

                allowOutsideClick: true,
                allowEscapeKey: true
            });

            if (result.isConfirmed) {
                props.onConfirm?.();
            } else {
                props.onCancel?.();
            }
        };

        showDialog();

        return () => {
            MySwal.close();
        };

    }, []);

    return null;
};

export default ConfirmDialog;